import React from 'react';
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from 'react-icons/md';
import {
  Global,
  TemplateProps,
} from '../../../../constants';
import { TodayWork } from './TodayWork';
import {
  ComboBox,
  ComboBoxModel,
  DateTextBox,
  FlexLayout,
  GridLayout,
  SearchLayout,
  TextBox,
} from '../../../../components';
import { Date8 } from '../../../../utils/time';
import { SearchBinding } from '../../../../models';
import { Fix } from '../../../../utils/string';

export const TodayWorkTemplate: React.FC<TemplateProps<TodayWork>> = ({
  scope,
}) => (
  <FlexLayout isVertical={true}>
    <SearchLayout size={Global.LAYOUT_SEARCH_HEIGHT_1}>
      <FlexLayout size={200}>
        <span>기간</span>
        <DateTextBox
          value={scope.state.stdate}
          textAlign="center"
          format="####-##-##"
          onChange={(value) => scope.setState({ stdate: value })}
          head={(<button
            onClick={() => {
              const date = new Date(Date8.withDash(scope.state.stdate));
              date.setDate(date.getDate() - 1);
              scope.setState({ stdate: Date8.make(date) },
                () => scope.onRetrieveEvent());
            }}
          >
            <MdKeyboardArrowLeft size={24}/>
          </button>)}
          trail={(<button
            onClick={() => {
              const date = new Date(Date8.withDash(scope.state.stdate));
              date.setDate(date.getDate() + 1);
              scope.setState({ stdate: Date8.make(date) },
                () => scope.onRetrieveEvent());
            }}
          >
            <MdKeyboardArrowRight size={24}/>
          </button>)}
          isDisabledTrackingStateChange={true}
        elField="stdate"
        >
        </DateTextBox>
      </FlexLayout>

      <FlexLayout size={170}>
        <span>상위부서</span>
        <ComboBox
          value={scope.state.kukcd}
          textAlign="center"
          data={[
            { value: '%', remark: '전체' },
            { value: '01', remark: '총무' },
            { value: '02', remark: '보수' },
          ].map((y) => new ComboBoxModel(y.value, y.remark))}
          onSelect={(option) => scope.SS({ kukcd: option.value })}
        elField="kukcd"
        >
        </ComboBox>
      </FlexLayout>

      <FlexLayout size={280}>
        <span style={{ color: 'var(--color-red)' }}>부서</span>
        <TextBox
          value={scope.state.divicd}
          textAlign="center"
          onChange={(value) => scope.SS({ divicd: value })}
          isDisabledTrackingStateChange={true}
          bindSearchModal={new SearchBinding(scope.props.modalStore, 'TB_JC002', {}, true, (item) => {
            scope.SS({
              divicd: item.cd,
              divinm: item.cdnm,
            });
            scope.onRetrieveEvent();
          })}
        elField="divicd"
        />
        <TextBox
          weight={1.2}
          value={scope.state.divinm}
          readonly={true}
        elField="divinm"
        />
      </FlexLayout>

      <FlexLayout size={280}>
        <span style={{ color: 'var(--color-red)' }}>담당자</span>
        <TextBox
          textAlign="center"
          value={scope.state.perid}
          onChange={(value) => scope.SS({ perid: value })}
          noPadding={true}
          bindSearchModal={new SearchBinding(scope.props.modalStore, 'TB_JA001', {}, true, (item) => {
            scope.SS({
              perid: item.cd,
              pernm: item.cdnm,
            });
            scope.onRetrieveEvent();
          })}
          isDisabledTrackingStateChange={true}
        elField="perid"
        />
        <TextBox
          weight={1.2}
          value={scope.state.pernm}
          readonly={true}
          onChange={(value) => scope.SS({ pernm: value })}
        elField="pernm"
        />
      </FlexLayout>
    </SearchLayout>

    <GridLayout
      ref={scope.grid}
      data={scope.state.workList}
      header={[
        {
          id: 'frtime',
          text: '시작시간',
          width: 40,
          render: (x) => (
            <FlexLayout
              justify="center"
              align="center"
            >
              {x.frtime.substr(0, 2)}:{x.frtime.substr(2, 2)}
            </FlexLayout>
          ),
        },
        {
          id: 'totime',
          text: '종료시간',
          width: 40,
          render: (x) => (
            <FlexLayout
              justify="center"
              align="center"
            >
              {x.totime.substr(0, 2)}:{x.totime.substr(2, 2)}
            </FlexLayout>
          ),
        },
        {
          id: 'divinm',
          text: '부서명',
          width: 60,
          render: (x) => (
            <FlexLayout
              justify="center"
              align="center"
            >
              {x.divinm}
            </FlexLayout>
          ),
        },
        {
          id: 'pernm',
          text: '사원명',
          width: 60,
          render: (x) => (
            <FlexLayout
              justify="center"
              align="center"
            >
              {x.pernm}
            </FlexLayout>
          ),
        },
        {
          id: 'rspnm',
          text: '직위',
          width: 40,
          render: (x) => (
            <FlexLayout
              justify="center"
              align="center"
            >
              {x.rspnm}
            </FlexLayout>
          ),
        },
        {
          id: 'overwk',
          text: '업무내역',
          width: 600,
          render: (x) => (
            <FlexLayout
              justify="left"
              align="center"
            >
              {Fix.newline(x.overwk)}
            </FlexLayout>
          ),
        },
      ]}
      rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
    elGrid="workList"
    >
    </GridLayout>
  </FlexLayout>);
